/*
  <iwt-scroll-media data-effect="zoom|parallax">
  Scroll-linked image motion: the image settles from a slight zoom (or drifts vertically)
  as its frame moves through the viewport.
*/
(() => {
  if (customElements.get('iwt-scroll-media')) return;

  class IwtScrollMedia extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('img, svg');
      this.effect = this.dataset.effect;
      if (!this.img || this.effect === 'none' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.queued = false;
      this.onScroll = () => {
        if (this.queued) return;
        this.queued = true;
        requestAnimationFrame(() => { this.queued = false; this.update(); });
      };
      this.io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      });
      this.io.observe(this);
      this.update();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      // 0 when the frame enters from below, 1 when it leaves at the top.
      const p = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      if (this.effect === 'zoom') {
        const scale = 1.18 - Math.min(1, p * 1.6) * 0.18;
        this.img.style.transform = `scale(${scale.toFixed(4)})`;
      } else {
        const shift = (p - 0.5) * -14;
        this.img.style.transform = `translate3d(0, ${shift.toFixed(2)}%, 0) scale(1.18)`;
      }
    }
  }

  customElements.define('iwt-scroll-media', IwtScrollMedia);
})();
